const CAMPAIGN_STORAGE_KEY = "telviora_campaign_data";
const ATTRIBUTION_WINDOW_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

const CAMPAIGN_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "wbraid",
  "gbraid",
  "fbclid",
  "ttclid",
  "msclkid",
];

export const captureCampaignData = (searchString = null) => {
  if (typeof window === "undefined") return {};

  const query = searchString != null ? searchString : window.location.search;
  if (!query) return getCampaignData();

  const searchParams = new URLSearchParams(query);
  const detectedParams = {};
  let hasCampaignParam = false;

  for (const key of CAMPAIGN_PARAM_KEYS) {
    const val = searchParams.get(key);
    if (val) {
      detectedParams[key] = val;
      hasCampaignParam = true;
    }
  }

  if (hasCampaignParam) {
    const dataToStore = {
      ...detectedParams,
      timestamp: Date.now(),
    };

    try {
      sessionStorage.setItem(CAMPAIGN_STORAGE_KEY, JSON.stringify(dataToStore));
      localStorage.setItem(CAMPAIGN_STORAGE_KEY, JSON.stringify(dataToStore));
    } catch (e) {
      console.warn("Failed to save campaign data:", e);
    }
    return dataToStore;
  }

  return getCampaignData();
};

export const getCampaignData = () => {
  if (typeof window === "undefined") return {};

  try {
    const raw = sessionStorage.getItem(CAMPAIGN_STORAGE_KEY) || localStorage.getItem(CAMPAIGN_STORAGE_KEY);
    if (!raw) return {};

    const parsed = JSON.parse(raw);
    if (parsed.timestamp && Date.now() - parsed.timestamp > ATTRIBUTION_WINDOW_MS) {
      localStorage.removeItem(CAMPAIGN_STORAGE_KEY);
      sessionStorage.removeItem(CAMPAIGN_STORAGE_KEY);
      return {};
    }
    return parsed;
  } catch {
    return {};
  }
};

export const appendCampaignParamsToUrl = (targetUrl) => {
  if (!targetUrl) return targetUrl;
  const campaignData = getCampaignData();
  if (!campaignData || Object.keys(campaignData).length === 0) {
    return targetUrl;
  }

  try {
    const url = new URL(targetUrl, typeof window !== "undefined" ? window.location.origin : "http://localhost");
    for (const key of CAMPAIGN_PARAM_KEYS) {
      if (campaignData[key] && !url.searchParams.has(key)) {
        url.searchParams.set(key, campaignData[key]);
      }
    }
    return url.toString();
  } catch (e) {
    return targetUrl;
  }
};
